<!-- APP CONTAINER -->
<div id="ContainerApp" [class]="appProperty.appStyleClass">
  @if (appProperty.loginPageNotVisible | async) {
  <nav class="navbar navbar-light navbar-suite">
    <div class="navbar-brand tb-launch-group">
      <button id="appsIcon" type="button" aria-label="App" class="tb-launch appsIcon amSuiteDefault"
        (click)="op.toggle($event)">
        <i aria-hidden="true" class="fa fa-th"></i>
      </button>
      <span class="tb-brand">
        <label class="amSuiteDefault appFunctionLabel" for="appsIcon">{{appProperty.appFuctionName}}</label>
      </span>
      <button id="myButton" type="button" class="btn btn-primary showNotifyButton" (click)="showNotify()"
        disabled></button>
    </div>

    <span class="tb-spacer" aria-hidden="true"></span>

    <div class="text-white user-section">
      @if (sessionService.getSession && userProperty.userSelectedCompany) {
      <div class="topbar-actions">
        @if (appProperty.impersonateIsActive) {
        <div class="impersonate-actions">
          @if (innerWidth >= 1000) {
          <p-button pRipple [loading]="impersonateLoader" icon="pi pi-user-minus"
            label=" {{ 'account.remove-impersonate' | translate }}" styleClass="p-button-sm topbar-impersonate-btn"
            (click)="removeImpersonate()"></p-button>
          }
          @if (innerWidth < 1000) { <p-button pRipple [loading]="impersonateLoader"
            icon="pi pi-user-minus" styleClass="p-button-sm topbar-impersonate-icon-btn"
            [pTooltip]="'account.remove-impersonate' | translate" tooltipPosition="bottom"
            (click)="removeImpersonate()">
            </p-button>
          }
        </div>
          }

          <!-- OAuth Provider Box -->
          @if (appStateHolder.oauthState.providers.length > 0) {
          <div class="oauth-providers-box">
            @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
            @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
            <div class="oauth-provider-item"
              [class.oauth-active]="getOAuthProviderStatus(provider.provider) === 'active'"
              [class.oauth-expiring]="getOAuthProviderStatus(provider.provider) === 'expiring'"
              [class.oauth-expired]="getOAuthProviderStatus(provider.provider) === 'expired'"
              [pTooltip]="provider.provider" tooltipPosition="bottom"
              (click)="showOAuthPanel($event, provider.provider)">
              <img src="assets/CustomIcons/microsoftprovider.svg" class="oauth-svg-icon-box microsoft-icon-box" />
            </div>
            }
            @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
            <div class="oauth-provider-item"
              [class.oauth-active]="getOAuthProviderStatus(provider.provider) === 'active'"
              [class.oauth-expiring]="getOAuthProviderStatus(provider.provider) === 'expiring'"
              [class.oauth-expired]="getOAuthProviderStatus(provider.provider) === 'expired'"
              [pTooltip]="provider.provider" tooltipPosition="bottom"
              (click)="showOAuthPanel($event, provider.provider)">
              <img src="assets/CustomIcons/jiraprovider.svg" class="oauth-svg-icon-box jira-icon-box" />
            </div>
            }
            }
          </div>
          }

          <div class="topbar-icon-actions tb-icons">
            <i class="pi pi-question-circle navActionIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
              [attr.aria-label]="'app.support-button' | translate" (click)="visibleSupportSidebar = true"></i>
            @if (alertsCount > 0) {
            <i class="pi pi-bell navActionIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
              [attr.aria-label]="'app.alerts-button' | translate" pBadge [value]="alertsCount" severity="info"
              (click)="visibleAlertSidebar = true"></i>
            }
            @if (alertsCount === 0) {
            <i class="pi pi-bell navActionIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
              [attr.aria-label]="'app.alerts-button' | translate" (click)="visibleAlertSidebar = true"></i>
            }
            @if (showAIIcon) {
            <i class="pi pi-sparkles aiIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
              [attr.aria-label]="'app.ai-assistant-button' | translate" (click)="visibleCopilotSidebar = true"></i>
            }
          </div>
      </div>
      }
      <div class="userInfo tb-user" role="button" tabindex="0" [attr.aria-label]="'app.user-profile-button' | translate"
        (click)="visibleSidebar = true">
        @if (sessionService.getSession && userProperty.userSelectedCompany) {
        <div class="userDefaultInfo who">
          <div class="username detail-user-bar">
            {{ sessionService.fullName }}
          </div>
          <div class="email">
            {{ sessionService.email }}
          </div>
          <div class="company-selected co">
            {{ userProperty.userSelectedCompany.name }}
          </div>
        </div>
        <span class="tb-avatar" aria-hidden="true">
          <i class="fa fa-user-circle-o userDefaultIcon" aria-hidden="true"></i>
        </span>
        }
      </div>
    </div>
  </nav>
  }

  <div>
    <!-- sidebar -->
    @if (sidebarSrv.showSidebar) {
    <div>
      <app-sidebar></app-sidebar>
    </div>
    }

    <!-- OUTLET FOR COMPONENT -->
    <div [@routeAnimations]="prepareOutlet(outlet)"
      [class]="sidebarSrv.showSidebar ? 'main-router-content' : 'no-sidebar-content'"
      [class.expanded]="sidebarSrv.isExpanded | async">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </div>

  @if (appProperty.loadingData | async) {
  <div class="spinneram">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
    Caricamento...
  </div>
  }
</div>

<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'"
  [showTransformOptions]="'translateX(100%)'" appendTo="body" key="addWidgetFromApp"></p-toast>
<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'"
  [showTransformOptions]="'translateX(100%)'" key="manageDash" appendTo="body"
  (click)="appStateHolder.clearToasts()"></p-toast>

<user-menu [visible]="visibleSidebar" (close)="visibleSidebar = false"></user-menu>

<alert [visible]="visibleAlertSidebar" (alertsCount)="updateAlertsCount($event)" (close)="visibleAlertSidebar = false">
</alert>


@if (visibleCopilotSidebar) {
<p-sidebar [(visible)]="visibleCopilotSidebar" [position]="drawerPosition"
  [transitionOptions]="'300ms cubic-bezier(0.25, 0.8, 0.25, 1)'" [styleClass]="getSidebarClass()"
  (onHide)="visibleCopilotSidebar = null">
  <ng-template pTemplate="header">
    <div class="copilotPanelHeader assist-head">
      <span class="assist-spark" aria-hidden="true">
        <i class="pi pi-sparkles sideBotIcon sideSparkleIcon"></i>
      </span>
      <span class="botTitle drawer-title">AmSuite Assistant</span>
    </div>
  </ng-template>
  <!-- <am-copilot [visible]="visibleCopilotSidebar" (close)="visibleCopilotSidebar = false"></am-copilot> -->
  <amsuite-assistant-bot #chatBot [bearerToken]="bearerToken" [dataOwnerId]="userProperty.userSelectedCompany?.id"
    [userModel]="sessionService.getSession" [idChat]="idChat" [userName]="sessionService.fullName" [source]="'amsuite'">
  </amsuite-assistant-bot>


</p-sidebar>
}

<support [visible]="visibleSupportSidebar" (close)="visibleSupportSidebar = false"></support>

<p-overlayPanel #op styleClass="app-menu" appendTo="body">
  <ng-template pTemplate>
    <div class="launch-grid" role="menu" [attr.aria-label]="'app.app-menu-label' | translate">
      @for (app of userProperty.userSelectedCompany.apps; track $index) {
      <div class="appSelector launch-item" [class]="app.cssParams?.appClass || ''" role="menuitem" tabindex="0"
        [attr.aria-label]="('app.select-app' | translate:{ appName: app.functionName })"
        (click)="onSelectApp(app); op.hide()">
        <button type="button" [class]="app.cssParams.menuItemClass" class="launch-tile" aria-hidden="true" tabindex="-1">
          <i [class]="app.cssParams.menuIconClass" aria-hidden="true"></i>
        </button>
        <label class="companyTruncate appName lab" [pTooltip]="app.functionName">{{app.functionName}}</label>
      </div>
      }
    </div>
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #oauthPanel styleClass="oauth-status-panel" appendTo="body">
  <ng-template pTemplate>
    <div class="oauth-panel-content" *ngIf="selectedOAuthProvider">
      <!-- Header con icona e nome provider -->
      <div class="oauth-panel-header">
        @if (selectedOAuthProvider === 'Office365' || selectedOAuthProvider === 'Microsoft') {
        <img src="assets/CustomIcons/microsoftprovider.svg" class="oauth-panel-svg-icon" />
        }
        @if (selectedOAuthProvider === 'Jira' || selectedOAuthProvider === 'Atlassian') {
        <img src="assets/CustomIcons/jiraprovider.svg" class="oauth-panel-svg-icon" />
        }
        <span class="oauth-provider-name">{{ selectedOAuthProvider }}</span>
      </div>

      <!-- Status content -->
      <div class="oauth-panel-status">
        @if (getOAuthProviderStatus(selectedOAuthProvider) === 'active') {
        <div class="oauth-status-item">
          <i class="pi pi-check-circle oauth-status-icon-active"></i>
          <div class="oauth-status-info">
            <div class="oauth-status-label">{{ 'oauth.active' | translate }}</div>
            <div class="oauth-status-expire">
              {{ 'oauth.expiresOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
              translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
            </div>
          </div>
        </div>
        }

        @if (getOAuthProviderStatus(selectedOAuthProvider) === 'expiring') {
        <div class="oauth-status-item">
          <i class="pi pi-exclamation-triangle oauth-status-icon-expiring"></i>
          <div class="oauth-status-info">
            <div class="oauth-status-label">{{ 'oauth.expiring' | translate }}</div>
            <div class="oauth-status-expire">
              {{ 'oauth.expiresOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
              translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
            </div>
          </div>
        </div>
        }

        @if (getOAuthProviderStatus(selectedOAuthProvider) === 'expired') {
        <div class="oauth-status-item">
          <i class="pi pi-times-circle oauth-status-icon-expired"></i>
          <div class="oauth-status-info">
            @if (formatOAuthExpiryDate(selectedOAuthProvider)) {
            <div class="oauth-status-label">{{ 'oauth.expired' | translate }}</div>
            <div class="oauth-status-expire">
              {{ 'oauth.expiredOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
              translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
            </div>
            }
            @if (!formatOAuthExpiryDate(selectedOAuthProvider)) {
            <div class="oauth-status-label">{{ 'oauth.notConfigured' | translate }}</div>
            }
          </div>
        </div>
        }
      </div>

      <!-- OAuth authorization button - always visible -->
      <div class="oauth-authorize-section">
        <p-button [raised]="true" [loading]="oauthAuthorizingProvider === selectedOAuthProvider"
          label="{{ 'oauth.authorize' | translate }}" styleClass="p-button-warning"
          (click)="authorizeOAuthProvider(selectedOAuthProvider); oauthPanel.hide()">
        </p-button>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>

